import { render, staticRenderFns } from "./AamsQualificationRegInfo.vue?vue&type=template&id=29595a47&scoped=true&"
import script from "./AamsQualificationRegInfo.vue?vue&type=script&lang=js&"
export * from "./AamsQualificationRegInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29595a47",
  null
  
)

export default component.exports